import React, { useEffect } from "react";
import { loanService } from "../../../../api/services/loanService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setAllLoanTypesData: (data: any) => void;
}
const DTOApplyLoanModal = ({ setAllLoanTypesData }: PropsValue) => {
  const selector = useAppSelector((state) => state.authSlice);

  async function getAllLoanTypes() {
    const respose: any = await loanService.getLoanTypes(selector.company_id);
    if (respose) {
      setAllLoanTypesData(respose?.get_loan_type);
    }
  }

  useEffect(() => {
    getAllLoanTypes();
  }, []);

  return <></>;
};

export default DTOApplyLoanModal;
